/**
 * Created by Yair on 11/12/2016.
 */

export function hideSpinner(className) {
    const spinner = document.getElementById('wt-spinner');
    document.body.classList.remove('spinner-on');
    document.getElementById('wt-spinner').style.display = 'none';
    spinner.classList.remove(className);
}

export function spinnerHasClass(className) {
    const spinner = document.getElementById('wt-spinner');
    return spinner.classList.contains(className);
}

export function showSpinner(className) {
    const spinner = document.getElementById('wt-spinner');
    document.body.classList.add('spinner-on');
    spinner.style.display = 'flex';
    if (className) {
        spinner.classList.add(className);
    }
}
